var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { attrs: { prop: "topic" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("Topic")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "topic" },
                    model: {
                      value: _vm.ruleForm.topic,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "topic", $$v)
                      },
                      expression: "ruleForm.topic",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "topic_power" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("topic权限")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      id: "topic_power",
                      insertContains: "topic_power",
                      name: "topic_power",
                      options: _vm.powerOptins,
                    },
                    model: {
                      value: _vm.ruleForm.topic_power,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "topic_power", $$v)
                      },
                      expression: "ruleForm.topic_power",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "topic_desc" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("描述")]),
                  ]),
                  _c("v-input", {
                    staticClass: "remarks",
                    attrs: {
                      type: "textarea",
                      name: "topic_desc",
                      maxlength: 200,
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.ruleForm.topic_desc,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "topic_desc", $$v)
                      },
                      expression: "ruleForm.topic_desc",
                    },
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: { visible: !_vm.upTips, name: "loading4" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }